import LottieAnimation from 'components/molecules/ExpertConfettiBurst/LottieAnimation.component';
import type { FC } from 'react';
import transferDataIntervatAnimation from './transferDataIntervat.lottie.json';

const TransferDataIntervatLottie: FC = () => (
  <LottieAnimation
    animationData={transferDataIntervatAnimation}
    height={82}
    width={200}
    isClickToPauseDisabled
    style={{ margin: 0, pointerEvents: 'none' }}
    options={{ loop: true, autoplay: true }}
  />
);

export default TransferDataIntervatLottie;
